module.exports = __webpack_public_path__ + "img/radio-keningau.84553559.jpg";